import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User applied a search query on the creative performance page',
  name: 'creative_performance_search_query_applied',
};

export default META;
